import { RouteRecordRaw } from 'vue-router';

import { ROUTE_PATH } from '~shared/config';
import { onlyUserNotAuthMiddleware } from '~shared/lib';

export const WAITING_CONFIRM_ROUTE: RouteRecordRaw = {
  name: 'WaitingConfirm',
  path: ROUTE_PATH.auth.waitingConfirm,
  component: () => import('./ui'),
  beforeEnter: [onlyUserNotAuthMiddleware],
  meta: {
    title: 'Base.WaitingConfirm',
  },
};
